import { MdOutlineHomeWork } from "react-icons/md";

import colors from "resources/theme/colors";
import Card1Horizontal from "components/Cards/Card1Horizontal";

function HeaderUnidade({
  nome,
  unidade,
  bloco,
}: {
  nome: string;
  unidade: string;
  bloco?: string;
}) {
  return (
    <Card1Horizontal
      iconWidth="60px"
      bg={colors.orange50}
      title={`${unidade ?? "--"} ${bloco ? `, ${bloco}` : ""}`}
      icon={<MdOutlineHomeWork fontSize="24px" color={colors.orange} />}
      description={`Nome do proprietário: ${nome ?? "--"}`}
      color={colors.orange}
    />
  );
}

export default HeaderUnidade;
